import myUtils from '../myUtils';
import apiConfig from './apiConfig';

const apiUrl = apiConfig.configApiUrl
const options = (method, body) => apiConfig.configOptions(method, body)
const callApi = (_url, _options) => apiConfig.configCallApi(_url, _options)

//=================== GroupChat API =============================//
const getGroupChats = async ({ page = 0, pageSize = 100000, keyWord, status, statusArray, groupType}) => {//Notice // page start at 0
    let propertyId = myUtils.getUser().propertyId;
    let paging = `,"limit":${pageSize > 0 ? pageSize : 100},"offset":${page*pageSize},"order":"lastUserMessageDateAt DESC"`; 

    let filterKeyWord = '';
    if(keyWord && keyWord != ''){
        filterKeyWord = `,"or":[{"name":{"like":"${keyWord}"}}, {"description":{"like":"${keyWord}"}}]`;
    }
    let filterStatus = '';
    if(status && status != ''){
        filterStatus = `,"status":"${status}"`;
    }else if(statusArray && statusArray.length > 0){
        filterStatus = `,"status":{"inq":${JSON.stringify(statusArray)}}`;
    } //,"scope":{"include":[{"relation":"homeMember","scope":{"include":[{"relation":"home"}]}}]}
    let filterGroupType = '';
    if(groupType && groupType != ''){
        filterGroupType = `,"groupType":"${groupType}"`;
    }
    const url = apiUrl+`/group-chats?filter={
        "where":{"active":true,"propertyId":"${propertyId}"${filterStatus}${filterKeyWord}${filterGroupType}},
        "include":[
            {"relation":"owner"}, 
            {"relation":"home"},
            {"relation":"homeMember"},
            {"relation":"chatTags","scope":{"where":{"active":true},"include":[{"relation":"tag"}]}}
        ] 
        ${paging} 
    }`;
    var resp = await callApi(url, options('GET'));

    return resp;
}


const getGroupChatDetail = async (groupChatId) => { //,"scope":{"include":[{"relation":"homeMember","scope":{"include":[{"relation":"home"}]}}]} , {"relation":"homeMember","scope":{"include":[{"relation":"home"}]}},
    const url = apiUrl+`/group-chats/${groupChatId}?filter={
        "include":[
            {"relation":"owner"}, 
            {"relation":"home"},
            {"relation":"chats","scope":{"include":[{"relation":"user"}]}},
            {"relation":"homeMember"},
            {"relation":"chatImages"},
            {"relation":"chatTags","scope":{"where":{"active":true},"include":[{"relation":"tag"}]}}
        ]
    }`;
    var resp = await callApi(url, options('GET'));

    return resp;
}

const createGroupChat = async (body) => {
    const url = apiUrl+`/group-chats`;
    const resp = callApi(url, options('POST', body));

    return resp;
}

const patchGroupChat = async (groupChatId, body) => {
    const url = apiUrl+`/group-chats/${groupChatId}`;
    var resp = await callApi(url, options('PATCH', body));

    return resp;
}

const deleteGroupChat = async (groupChatId) => {
    const url = apiUrl+`/group-chats/${groupChatId}`;
    var resp = await callApi(url, options('PATCH', {active:false}));

    return resp;
}

const getBadgeAllGroupChats = async ({groupType}) => {//Notice // page start at 0
    let propertyId = myUtils.getUser().propertyId;
    let paging = `,"limit":100000000,"offset":0`; 

    let filterGroupType = '';
    if(groupType){
        filterGroupType = `,"groupType":"${groupType}"`;
    }
    const url = apiUrl+`/group-chats?filter={"where":{"active":true,"badgeStaff":{"gt": 0},"propertyId":"${propertyId}"${filterGroupType}} ${paging}}`;
    var resp = await callApi(url, options('GET'));
    // console.log(url);

    // console.log(JSON.stringify(resp));

    var countBadgeStaffs = 0;
    if(resp){
        const { response } = resp ?? {};
        if(response && response.length > 0){
            for (const gc of response) {
                countBadgeStaffs += gc.badgeStaff ?? 0;
            }
        }
    }
    return countBadgeStaffs;
}

const countGroupChats = async ({status, statusArray, keyWord, groupType}) => {
    let propertyId = myUtils.getUser().propertyId;
    let filterKeyWord = '';
    if(keyWord && keyWord != ''){
        filterKeyWord = `,"or":[{"homeNumber":{"like":"${keyWord}"}}]`;
    }
    let filterStatus = '';
    if(status && status != ''){
        filterStatus = `,"status":"${status}"`;
    }else if(statusArray && statusArray.length > 0){
        filterStatus = `,"status":{"inq":${JSON.stringify(statusArray)}}`;
    }
    let filterGroupType = '';
    if(groupType && groupType != ''){
        filterGroupType = `,"groupType":"${groupType}"`;
    }
    const countUrl = `${apiUrl}/group-chats/count?where={"active":true,"propertyId":"${propertyId}"${filterStatus}${filterKeyWord}${filterGroupType}}`;
    var resp = await callApi(countUrl, options('GET'));

    return resp;
}

//Chat
const createChat = async (body) => {
    const url = apiUrl+`/chats`;
    const resp = callApi(url, options('POST', body));

    return resp;
}

const createChatImage = async (body) => {
    const url = apiUrl+`/chat-images`;
    const resp = await callApi(url, options('POST', body));
    return resp;
}

const deleteChatImage = async (chatImageId) => {
    const url = apiUrl+`/chat-images/${chatImageId}`;
    var resp = await callApi(url, options('PATCH', {active:false}));
   
    return resp;
}

export default {//GroupChat API
    getGroupChats,
    getGroupChatDetail,
    createGroupChat,
    patchGroupChat,
    deleteGroupChat,
    getBadgeAllGroupChats,
    countGroupChats,

    createChat,
    createChatImage,
    deleteChatImage,

}